var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.depViewer.opened === true
        ? _c(
            "div",
            {
              staticClass: "modal-mask",
              attrs: { id: "StatusDependenciesViewerDialog" },
            },
            [
              _c("div", { staticClass: "modal-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "modal-dialog modal-xl modal-dialog-scrollable",
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c("h5", { staticClass: "modal-title" }, [
                          _vm._v("Status dependencies"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.depViewer.close()
                              },
                            },
                          },
                          [_vm._v("×")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        !_vm.depViewer.rm
                          ? _c("h4", [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                              _vm._v(
                                " Checking dependencies...\n                        "
                              ),
                            ])
                          : _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "alert alert-warning text-dark",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _c("p", [
                                    _vm._v("The status '"),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.depViewer.rm.Name)),
                                    ]),
                                    _vm._v("' is used in "),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.depViewer.rm.Count)),
                                    ]),
                                    _vm._v(" places."),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.depViewer.rm.Reports.length > 0
                                ? _c("div", { staticClass: "card mt-3" }, [
                                    _c("div", { staticClass: "card-header" }, [
                                      _vm._v(
                                        "\n                                    Reports (" +
                                          _vm._s(
                                            _vm.depViewer.rm.Reports.length
                                          ) +
                                          ")\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush",
                                      },
                                      _vm._l(
                                        _vm.depViewer.rm.Reports,
                                        function (r) {
                                          return _c(
                                            "li",
                                            {
                                              key: r.Id,
                                              staticClass: "list-group-item",
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "sanitizedHref",
                                                      rawName:
                                                        "v-sanitizedHref",
                                                      value: r.Url,
                                                      expression: "r.Url",
                                                    },
                                                  ],
                                                  staticClass: "text-primary",
                                                  attrs: { target: "_blank" },
                                                },
                                                [_vm._v(_vm._s(r.Name))]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.depViewer.rm.Lists.length > 0
                                ? _c("div", { staticClass: "card mt-3" }, [
                                    _c("div", { staticClass: "card-header" }, [
                                      _vm._v(
                                        "\n                                    Lists (" +
                                          _vm._s(
                                            _vm.depViewer.rm.Lists.length
                                          ) +
                                          ")\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush",
                                      },
                                      _vm._l(
                                        _vm.depViewer.rm.Lists,
                                        function (l) {
                                          return _c(
                                            "li",
                                            {
                                              key: l.Id,
                                              staticClass: "list-group-item",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(l.Name)),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.depViewer.rm.Notifications.length > 0
                                ? _c("div", { staticClass: "card mt-3" }, [
                                    _c("div", { staticClass: "card-header" }, [
                                      _vm._v(
                                        "\n                                    Notifications (" +
                                          _vm._s(
                                            _vm.depViewer.rm.Notifications
                                              .length
                                          ) +
                                          ")\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush",
                                      },
                                      _vm._l(
                                        _vm.depViewer.rm.Notifications,
                                        function (n) {
                                          return _c(
                                            "li",
                                            {
                                              key: n.Id,
                                              staticClass: "list-group-item",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(n.Name)),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.depViewer.rm.Alternatives.length > 0
                                ? _c("div", { staticClass: "card mt-3" }, [
                                    _c("div", { staticClass: "card-header" }, [
                                      _vm._v(
                                        "\n                                    Alternatives (" +
                                          _vm._s(
                                            _vm.depViewer.rm.Alternatives.length
                                          ) +
                                          ")\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush",
                                      },
                                      _vm._l(
                                        _vm.depViewer.rm.Alternatives,
                                        function (a) {
                                          return _c(
                                            "li",
                                            {
                                              key: a.Id,
                                              staticClass: "list-group-item",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(a.Name)),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.depViewer.close()
                              },
                            },
                          },
                          [_vm._v("Close")]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.statusDeleter.opened === true
        ? _c(
            "div",
            { staticClass: "modal-mask", attrs: { if: "StatusDeleterDialog" } },
            [
              _c("div", { staticClass: "modal-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "modal-dialog modal-lg modal-dialog-scrollable",
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "modal-header",
                          class: {
                            "bg-danger":
                              _vm.statusDeleter.rm &&
                              _vm.statusDeleter.rm.HasDependants === false,
                          },
                        },
                        [
                          _c("h5", { staticClass: "modal-title" }, [
                            _vm._v("Delete status"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.statusDeleter.close()
                                },
                              },
                            },
                            [_vm._v("×")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        !_vm.statusDeleter.rm
                          ? _c("h4", [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                              _vm._v(
                                " Checking dependencies...\n                        "
                              ),
                            ])
                          : _c("div", [
                              _vm.statusDeleter.rm.HasDependants === true
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "alert alert-danger text-dark",
                                        attrs: { role: "alert" },
                                      },
                                      [
                                        _c(
                                          "h5",
                                          { staticClass: "alert-heading" },
                                          [_vm._v("Cannot delete this status")]
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n                                        The status '"
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.statusDeleter.rm.Name)
                                            ),
                                          ]),
                                          _vm._v("' is used in "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.statusDeleter.rm.Count)
                                            ),
                                          ]),
                                          _vm._v(
                                            " places.\n                                        To delete this status, first remove it from where it is used.\n                                    "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _c("div", [
                                    _c("h4", [
                                      _vm._v(
                                        "Are you sure you want to delete this status?"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("You are about to delete '"),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.statusDeleter.rm.Name)
                                        ),
                                      ]),
                                      _vm._v("'. This can't be undone."),
                                    ]),
                                  ]),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _vm.statusDeleter.rm?.HasDependants === false
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-danger",
                                attrs: { type: "button" },
                                on: {
                                  click: _vm.handleDeleteKanbanStatusCommand,
                                },
                              },
                              [_vm._v("Delete")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.statusDeleter.rm?.HasDependants === true
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showStatusDependenciesViewer(
                                      _vm.statusDeleter.rm.Id
                                    )
                                  },
                                },
                              },
                              [_vm._v("View dependencies")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.statusDeleter.close()
                              },
                            },
                          },
                          [_vm._v("Cancel")]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { type: "button" },
                  on: { click: _vm.createStatus },
                },
                [_vm._v("Add status")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { type: "button" },
                  on: { click: _vm.handleUpdateKanbanStatusesCommand },
                },
                [_vm._v("Save changes")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c("div", { staticClass: "container" }, [
            _vm.AlternativeStatusesView.length === 0
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-danger",
                    attrs: { role: "alert" },
                  },
                  [
                    _c("strong", [_vm._v("No statuses")]),
                    _vm._v(" - there must be at least one status.\n        "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.errors?.length
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-danger",
                    attrs: { role: "alert" },
                  },
                  _vm._l(_vm.errors, function (e) {
                    return _c("p", [
                      _vm._v(
                        "\n                " +
                          _vm._s(e.Error) +
                          "\n            "
                      ),
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table table-bordered" },
              _vm._l(_vm.AlternativeStatusesView, function (s) {
                return _c("tr", { key: s.OrderValue }, [
                  _c("td", { staticStyle: { width: "120px" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { "max-width": "40px", width: "40px" },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.moveUp(s)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-long-arrow-up",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { "max-width": "40px", width: "40px" },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.moveDown(s)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-long-arrow-down",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "form-group m-0 p-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: s.Name,
                            expression: "s.Name",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: s.Name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(s, "Name", $event.target.value.trim())
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticStyle: { width: "90px" } }, [
                    _c("div", { staticClass: "dropdown" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary dropdown-toggle",
                          attrs: { type: "button", "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n                            Actions\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu dropdown-menu-right" },
                        [
                          s.Id
                            ? _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showStatusDependenciesViewer(
                                        s.Id
                                      )
                                    },
                                  },
                                },
                                [_vm._v("View dependencies")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteStatus(s)
                                },
                              },
                            },
                            [_vm._v("Delete")]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Kanban statuses")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }